<button
  mat-stroked-button
  [matMenuTriggerFor]="actionMenu"
  [disabled]="!operationContainer?.operations?.length"
  [disabledInteractive]="!operationContainer?.operations?.length"
  [matTooltip]="'TRANS__VALIDATION__NO_SELECTED_OBJECT' | translate"
  [matTooltipDisabled]="!!operationContainer?.operations?.length"
  type="button"
  class="admin-stroked-button"
>
  <mat-icon>more_horiz</mat-icon>
  <span class="bold uppercase admin-stroked-button__left-margin">
    {{ 'TRANS__ADMIN_CONCEPT__ACTION_MENU__TITLE' | translate }}
  </span>
</button>

<mat-menu
  #actionMenu="matMenu"
  xPosition="before"
  class="removePaddingInMatMenu admin-action-list-menu"
>
  @if (operationContainer?.operations?.length) {
    <ng-container>
      @for (subOperation of operationContainer.operations[0].sub_operations; track $index) {
        <ng-container>
          <div
            [matTooltip]="subOperation.$$toolTip"
            [matTooltipDisabled]="!subOperation.$$disabled"
          >
            <button
              mat-menu-item
              (click)="openOperation(subOperation)"
              [disabled]="subOperation.$$disabled"
              class="admin-action-list-menu__button"
            >
              @if (subOperation.menu_icon) {
                @if (!subOperation.menu_icon.startsWith('icon-')) {
                  <mat-icon>
                    {{subOperation.menu_icon}}
                  </mat-icon>
                }
                @else {
                  <div class="admin-action-list-menu__icon-legacy">
                    <i [ngClass]="subOperation.menu_icon"></i>
                  </div>
                }
              }
              <span class="admin-action-list-menu__label">
                {{ subOperation.menu_title | translate }}
              </span>
            </button>
          </div>
        </ng-container>
      }
    </ng-container>
  }

  @for (conceptMenu of menus; track $index) {
    <!-- Displaying the old type 'join concepts' menu, remember to remove when all backends are >= 10.0.239 -->
    <button
      mat-menu-item
      (click)="conceptMenu.action()"
      [disabled]="conceptMenu.disabled()"
    >
      <mat-icon>
        {{conceptMenu.icon}}
      </mat-icon>
      <span>
        {{ conceptMenu.title | translate }}
      </span>
    </button>
  }
</mat-menu>
